import React, {
  CSSProperties,
  MutableRefObject,
  PropsWithChildren,
  useRef,
} from 'react';
import { Button as _BootstrapButton } from 'react-bootstrap';
import {
  isChrome,
  isChromium,
  isEdge,
  isEdgeChromium,
  isFirefox,
  isIOS,
  isMobileSafari,
  isOpera,
  isSafari,
} from 'react-device-detect';
import { ButtonType } from '@restart/ui/Button';
import classNames from 'classnames';

const BootstrapButton = _BootstrapButton as any;

export type SBButtonVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'custom'
  | 'info'
  | 'outline'
  | 'outline-danger'
  | 'option'
  | 'danger'
  | 'link'
  | 'link-danger';

export type SBButtonProps = PropsWithChildren<{
  // bootstrap button properties, passed down
  id?: string; // TODO make this required?
  disabled?: boolean;
  title?: string;
  variant?: SBButtonVariant;
  type?: ButtonType;
  tabIndex?: number;
  size?: 'sm' | 'lg';
  href?: string | undefined;
  style?: CSSProperties | string;

  // our properties
  className?: string;
  innerRef?: MutableRefObject<HTMLButtonElement | null>;
  onFocus?: () => void;
  onClick?: (event: React.MouseEvent) => void;
}>;

export const SBButton: React.FC<SBButtonProps> = ({
  className,
  innerRef,
  onFocus,
  onClick,
  children,
  ...bootstrapButtonProps
}) => {
  const ref = useRef<HTMLButtonElement>();
  const focusedRef = useRef<boolean>(false);

  return (
    <BootstrapButton
      {...bootstrapButtonProps}
      className={classNames(['button', className])}
      // block
      onFocus={() => {
        onFocus && onFocus();
        focusedRef.current = true;
      }}
      onBlur={() => {
        focusedRef.current = false;
      }}
      onClick={(e: React.MouseEvent) => {
        // TODO
        // Safari buttons aren't able to gain focus.
        if (
          !(
            // Browsers we know definitely work
            (
              (isChrome ||
                isFirefox ||
                isOpera ||
                isEdge ||
                isChromium ||
                isEdgeChromium) &&
              !(isMobileSafari || isSafari || isIOS)
            )
          ) ||
          // Focused check is to stop buttons from being activated when
          // we're trying to trap the user's focus in a field that has
          // front-end validation issues.
          focusedRef.current
        ) {
          if (onClick) {
            onClick(e);
          }
        }
      }}
      ref={innerRef || ref}
    >
      {children}
    </BootstrapButton>
  );
};
